<template>
  <v-form @submit.prevent="onSubmit" ref="formRef">

        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="4" sm="6"  >
              <v-text-field v-model="form.title" label="Título" variant="outlined" required></v-text-field>
            </v-col>

            <v-col cols="12" md="8" sm="12" >
              <v-text-field v-model="form.category" label="Categoría" variant="outlined"></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6" >
              <v-text-field v-model="form.filter" label="Filtro*" variant="outlined" />
            </v-col>

            <v-col cols="12" md="4" sm="6" >

            <v-select 
              v-model="form.adicional_class"
              label="Orientacion"
              :items="[
                { title: 'NONE', value: '' },
                { title: 'vertical', value: 'vertical' },
                { title: 'horizontal', value: 'featured' }
              ]"
              item-title="title"
              item-value="value"
              variant="outlined"
            />
              <!-- <v-text-field v-model="form.adicional_class" label="Clase adicional" variant="outlined" /> -->
            </v-col>

            <v-col cols="12" md="4" sm="6" >
            <v-select 
              v-model="form.type"
              label="Tipo"
              :items="['CRIS', 'HOME']"
              item-title="Tipo*"
              item-value="type"
              variant="outlined"
            />
            </v-col>

            <v-col cols="12" sm="3" >
            <v-select
              v-model="form.status"
              label="Estado"
              :items="['A', 'I']"
              item-title="status"
              item-value="status"
              variant="outlined"
            />
            </v-col>
            <v-col cols="12" md="9" sm="12" >
              <v-file-input
                label="Imagen"
                accept="image/*"
                v-model="imageFile"
                @change="handleImagePreview"
                prepend-icon=""
                show-size
                chips
                :hint="imageFile ? imageFile.name : form.image"
                persistent-hint
                variant="outlined"
              />
            </v-col>
            <v-col cols="12" md="12" sm="12" >
              <v-img
                :src="imagePreview || getImagePath(form.image) || ''"
                max-height="300"
                class="my-2 rounded"
                cover
              />
            </v-col>
            <v-col cols="12" md="12" sm="12" >
              <v-textarea v-model="form.description" label="Descripción" rows="2" variant="outlined" />
            </v-col>
          </v-row>

          <small class="text-caption text-medium-emphasis">*indicates required field</small>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>


          <v-btn
            v-if="!isEdit"
            color="primary"
            text="Guardar"
            variant="tonal"
            :loading="props.loading"
            @click="onSubmit2"
          ></v-btn>
          <v-btn
            v-if="isEdit"
            color="primary"
            text="editar"
            variant="tonal"
            type="submit"
            :loading="props.loading"
          ></v-btn>
          <v-btn
            text="Cancelar"
            variant="plain"
            @click="$emit('cancel')"
          ></v-btn>
        </v-card-actions>
  </v-form>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { HOST_URL_IMGS } from '@/utils/constantes';
import { GalleryItem } from '@/interfaces/gallery.interface';

const props = defineProps<{
  modelValue: GalleryItem
  isEdit?: boolean,
  loading?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: GalleryItem): void
  (e: 'submit', value: { data: GalleryItem; imageFile: File | null }): void
  (e: 'submit2', value: { data: GalleryItem; imageFile: File | null }): void
  (e: 'cancel'): void
}>()

const form = ref<GalleryItem>({ ...props.modelValue })
const imageFile = ref<File | null>(null)
const imagePreview = ref<string | null>(null)
const formRef = ref() 
let previousUrl: string | null = null

watch(() => props.modelValue, (newVal) => {
  form.value = { ...newVal }
  imagePreview.value = getImagePath(newVal.image) //newVal.image?.startsWith('http') ? newVal.image : null
})
function getImagePath(path: string) {
    const baseURL = `${HOST_URL_IMGS}/public/imgs/output`
    return path.startsWith('http') ? path : baseURL +'/'+ path
}

watch(imageFile, (newVal) => {
  if (!newVal) {
    // Si el usuario borra la imagen (con la x)
    imagePreview.value = getImagePath(form.value.image)
    previousUrl = null
  }
})
function handleImagePreview() {
  if (imageFile.value instanceof Blob) {
    // Si hay archivo nuevo seleccionado
    if (previousUrl) {
      URL.revokeObjectURL(previousUrl)
    }
    const url = URL.createObjectURL(imageFile.value)
    imagePreview.value = url
    previousUrl = url
  } else {
    // Si el archivo se eliminó, restablecer imagen original
    imagePreview.value = getImagePath(form.value.image)
    previousUrl = null
  }
}

function onSubmit() { 
  form.value.updated_at = new Date().toISOString()
  if (!props.isEdit) {
    form.value.created_at = form.value.updated_at
  }

  emit('submit', { data: form.value, imageFile: imageFile.value })
}

function onSubmit2() {
  form.value.updated_at = new Date().toISOString()
  if (!props.isEdit) {
    form.value.created_at = form.value.updated_at
  }
  emit('submit2', { data: form.value, imageFile: imageFile.value })
}
</script>
